(() => {
  'use strict';
  const optionType = name => {
    const key = name.toLowerCase().trim();
    if (/^(colou?rs?|couleur|اللون|الألوان|الوان|لون)$/.test(key)) return 'color';
    if (/^(sizes?|größe|المقاس|الحجم)$/.test(key)) return 'size';
    return null;
  };
  const filterTypes = new Map();
  const filterValues = new Map();
  const paramType = name => filterTypes.get(name) || (name.toLowerCase().startsWith('filter.v.option.') ? optionType(name.slice(16)) : null);
  const arabicColors = {"أبيض": "white", "وردي": "pink", "أزرق": "blue", "كحلي": "navy", "أخضر": "green", "بيج": "beige", "أحمرالكرز": "cherryred", "أحمركرزي": "cherryred", "رمادي": "gray", "أنثراسايت": "anthracite", "أحمر": "red", "تيفاني": "tiffany", "برتقالي": "orange", "فضي": "silver", "أصفر": "yellow", "كحلي/فضي": "navy/silver", "رمادي/قرميدي": "grey/tile", "كحلي/أزرق": "navy/blue", "أخضر/بيج": "green/beige", "نعناعي": "mint", "بنفسجي": "purple", "ذهبيوردي": "rosegold", "ليلكي": "lilac"};
  const canonical = value => {
    const key = String(value).trim().toLowerCase().replace(/[\s_-]+/g, '');
    return arabicColors[key] || ({grey:'gray',lightgrey:'lightgray',darkgrey:'darkgray',mintgreen:'mint','أبيض':'white','ابيض':'white','أسود':'black','اسود':'black','وردي':'pink','أزرق':'blue','ازرق':'blue','أخضر':'green','اخضر':'green','كحلي':'navy','بيج':'beige','أحمر':'red','احمر':'red','أحمرقِرْمِزي':'cherryred','أحمرقرمزي':'cherryred','أحمرِكرزي':'cherryred','أحمركرزي':'cherryred','اصفر':'yellow','أصفر':'yellow','رمادي':'gray','رماديفاتح':'lightgray','رماديداكن':'darkgray','نعناعي':'mint','نعناع':'mint','النعناع':'mint','أخضرنعناعي':'mint','اخضرنعناعي':'mint','أخضرفاتح':'lightgreen','اخضرفاتح':'lightgreen','أخضرداكن':'darkgreen','اخضرداكن':'darkgreen','بنفسجي':'purple','موف':'mauve','بني':'brown','برتقالي':'orange'})[key] || key;
  };
  const selections = url => {
    const groups = {color:new Set(),size:new Set()};
    for (const [name,value] of url.searchParams) {
      const type = paramType(name);
      if (type) value.split(',').forEach(v => {if (v.trim()) groups[type].add(canonical(filterValues.get(name+'|'+v) || v));});
    }
    return groups;
  };
  const matchingVariant = (product, groups, readyOnly = false) => product.variants.find(variant => variant.available && (!readyOnly || (product.priced && product.has_image && Number(variant.price) > 0)) && Object.entries(groups).every(([type,values]) => !values.size || product.options.some((name,index) => optionType(name) === type && values.has(canonical(variant.options[index])))));
  const candidateURL = (url, section, page) => {
    const candidate = new URL(url);
    for (const name of [...candidate.searchParams.keys()]) if (paramType(name) || name === 'page' || name === 'bm_page') candidate.searchParams.delete(name);
    if (candidate.pathname.endsWith('/search')) candidate.searchParams.set('type','product');
    candidate.searchParams.set('section_id',section);
    candidate.searchParams.set('page',page);
    return candidate;
  };
  window.BumpinoCatalog = {canonical, optionType, paramType, selections, matchingVariant, candidateURL};
  const initial = new URL(location.href);
  const arrivals = /\/collections\/new-arrivals\/?$/.test(initial.pathname);
  let selected = selections(initial);
  let active = arrivals || selected.color.size || selected.size.size;
  if (active || [...initial.searchParams.keys()].some(name=>/filter\.[pv]\.m\..*(color|colour|size)/i.test(name))) document.documentElement.classList.add('bumpino-catalog-verifying');
  const groupsByScope = () => {
    for (const form of document.querySelectorAll('#FacetFiltersForm')) {
      const groups = new Map();
      for (const facet of form.querySelectorAll('[data-bumpino-filter]')) {
        const type = paramType(facet.dataset.bumpinoFilter);
        if (!type) continue;
        if (!groups.has(type)) groups.set(type,[]);
        groups.get(type).push(facet);
      }
      for (const [type,facets] of groups) {
        const values = new Map();
        for (const facet of facets) {
          for (const anchor of facet.querySelectorAll('li > a')) {
            const li = anchor.closest('li');
            const value = anchor.dataset.bumpinoValue;
            if (value === undefined || !value.trim()) {li.remove();continue;}
            const key = canonical(anchor.dataset.bumpinoLabel || filterValues.get(facet.dataset.bumpinoFilter+'|'+value) || value);
            if (!values.has(key)) values.set(key,{li,anchor,entries:[]});
            const group = values.get(key);
            const originalEntries=anchor.dataset.bumpinoEntries ? JSON.parse(anchor.dataset.bumpinoEntries) : [[facet.dataset.bumpinoFilter,value]];
            for (const entry of originalEntries) if (!group.entries.some(item=>item[0]===entry[0] && item[1]===entry[1])) group.entries.push(entry);
            if (group.li !== li) li.remove();
          }
        }
        const target = facets[0].querySelector('ul');
        for (const [key,group] of values) {
          const {li,anchor,entries} = group;
          target.append(li);
          li.classList.remove('is--disabled');
          li.classList.toggle('is--selected',selected[type].has(key));
          anchor.dataset.bumpinoEntries = JSON.stringify(entries);
          anchor.dataset.bumpinoType = type;
          anchor.dataset.bumpinoKey = key;
          anchor.querySelector('.t4s-value-count')?.remove();
          const href = new URL(location.href);
          for (const name of [...href.searchParams.keys()]) {
            if (paramType(name) !== type) continue;
            const remaining = href.searchParams.getAll(name).flatMap(v => v.split(',')).filter(v => canonical(filterValues.get(name+'|'+v) || v) !== key);
            href.searchParams.delete(name);
            remaining.forEach(v => href.searchParams.append(name,v));
          }
          if (!selected[type].has(key)) entries.forEach(([name,value]) => href.searchParams.append(name,value));
          href.searchParams.delete('page');href.searchParams.delete('bm_page');
          anchor.href = href.href;
        }
        facets.slice(1).forEach(facet => facet.remove());
      }
    }
  };
  document.addEventListener('click',event => {
    const sort = event.target.closest('[data-sortby-item]');
    const anchor = event.target.closest('a');
    const priceButton = event.target.closest('.t4s-price_slider_btn');
    if (active && priceButton) {
      event.preventDefault();event.stopImmediatePropagation();
      const amount=priceButton.closest('.t4s-price_slider_amount');const url=new URL(location.href);
      url.searchParams.set(amount.dataset.minstr,amount.querySelector('.t4s-min_price').value);url.searchParams.set(amount.dataset.maxstr,amount.querySelector('.t4s-max_price').value);url.searchParams.delete('page');url.searchParams.delete('bm_page');location.assign(url);return;
    }
    if (active && sort) {
      event.preventDefault();event.stopImmediatePropagation();
      const url = new URL(location.href);url.searchParams.set('sort_by',sort.dataset.value);url.searchParams.delete('page');url.searchParams.delete('bm_page');location.assign(url);return;
    }
    if (!anchor || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (anchor.dataset.bumpinoEntries || (active && anchor.closest('[data-filter-links], [data-sidebar-links], .t4s-active-filters'))) {
      event.preventDefault();event.stopImmediatePropagation();location.assign(anchor.href);
    }
  },true);
  const observer = new MutationObserver(() => {observer.disconnect();groupsByScope();observer.observe(document.body,{subtree:true,childList:true});});
  const start = async () => {
    const dataNode = document.querySelector('[data-bumpino-catalog-data]');
    const data = dataNode ? JSON.parse(dataNode.textContent) : null;
    for (const filter of data?.option_filters || []) {
      const type=optionType(filter.label) || paramType(filter.name);
      if (!type) continue;
      filterTypes.set(filter.name,type);
      for (const value of filter.values) filterValues.set(filter.name+'|'+value.value,value.label);
    }
    selected=selections(initial);active=arrivals || selected.color.size || selected.size.size;
    groupsByScope();observer.observe(document.body,{subtree:true,childList:true});
    if (!active) {document.documentElement.classList.remove('bumpino-catalog-verifying');return;}
    if (!dataNode) {document.documentElement.classList.remove('bumpino-catalog-verifying');return;}
    const section = dataNode.closest('[id^="shopify-section-"]');
    const container = section.querySelector('[data-ntajax-container]');
    if (!container) return;
    const status = document.createElement('p');status.className='bumpino-catalog-status';status.setAttribute('role','status');status.setAttribute('aria-live','polite');status.textContent=data.messages.loading;container.before(status);
    const searchHeading=document.querySelector('[data-bumpino-search-heading]');
    if (searchHeading) searchHeading.textContent=data.messages.loading;
    const cards = new Map();let firstDoc;
    try {
      const getPage = async page => {
        const response = await fetch(candidateURL(initial,data.section,page),{credentials:'same-origin',headers:{'Cache-Control':'no-cache'},...(window.AbortSignal?.timeout ? {signal:window.AbortSignal.timeout(20000)} : {})});
        if (!response.ok) throw Error('Candidate fetch failed');
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const payload = doc.querySelector('[data-bumpino-catalog-data]');
        if (!payload) throw Error('Missing candidate data');
        const pageData = JSON.parse(payload.textContent);
        if (pageData.products.some(product => !product.complete || product.variants.length < product.variant_count)) throw Error('Incomplete variant data');
        const candidateCards = [...doc.querySelectorAll('[data-contentlm-replace] > .t4s-product')];
        for (const product of pageData.products) {
          const variant = matchingVariant(product,selected,arrivals);
          if (!variant) continue;
          const card = candidateCards.find(node => String(JSON.parse(node.dataset.productOptions || '{}').id) === product.id || node.classList.contains('t4s-pr-'+product.id));
          if (!card) throw Error('Missing candidate card');
          const matchingCard = card.cloneNode(true);
          for (const link of matchingCard.querySelectorAll('a[href]')) {
            const href = new URL(link.getAttribute('href'),location.origin);
            if (href.pathname.endsWith('/products/'+product.handle) && !link.closest('.bumpino-card-swatches')) {href.searchParams.set('variant',variant.id);link.href=href.pathname+href.search;}
          }
          cards.set(product.id,{card:matchingCard,page,index:pageData.products.indexOf(product)});
        }
        return {doc,pageData};
      };
      const first = await getPage(1);firstDoc=first.doc;
      if (first.pageData.items > 25000 || first.pageData.pages * first.pageData.page_size > 25000) throw Error('Pagination limit');
      for (let page=2;page<=first.pageData.pages;page+=3) await Promise.all(Array.from({length:Math.min(3,first.pageData.pages-page+1)},(_,i)=>getPage(page+i)));
      const source = firstDoc.querySelector('[data-ntajax-container]');
      const grid = source.querySelector('[data-contentlm-replace]');
      if (!grid && cards.size) throw Error('Missing candidate grid');
      if (!grid) source.replaceChildren();
      source.querySelectorAll('.t4s-active-filters__count, .t4s-prs-footer, [data-wrap-lm], [data-wrap-lm-prev], .t4s-no-result-product, .t4s-search-suggest').forEach(node=>node.remove());
      source.querySelectorAll('.t4s-active-filters').forEach(node=>{if (!node.querySelector('a')) node.remove();});
      const results = [...cards.values()].sort((a,b)=>a.page-b.page || a.index-b.index).map(item=>item.card);
      const pageSize = first.pageData.page_size || 24;
      const pages = Math.max(1,Math.ceil(results.length/pageSize));
      const currentPage = Math.min(pages,Math.max(1,Number(initial.searchParams.get('bm_page') || initial.searchParams.get('page'))||1));
      if (grid) {
        grid.classList.remove('isotopet4s');grid.removeAttribute('data-isotopet4s-js');grid.style.height='';
        grid.replaceChildren(...results.slice((currentPage-1)*pageSize,currentPage*pageSize));
        grid.querySelectorAll('[timeline], [hdt-reveal]').forEach(node=>{node.removeAttribute('timeline');node.removeAttribute('hdt-reveal');});
      }
      // Keep the live node so native Kalles facets can initialize before or after verification.
      container.replaceChildren(...source.childNodes);
      const filtered = selected.color.size || selected.size.size;
      const countMessage = arrivals && !filtered ? data.messages.arrival_count : data.messages.count;
      const emptyMessage = arrivals && !filtered ? data.messages.arrival_empty : data.messages.empty;
      status.textContent=results.length ? countMessage.replace('__BUMPINO_COUNT__',results.length).replace('{{ count }}',results.length) : emptyMessage;
      if (searchHeading) searchHeading.textContent=data.messages.search_heading.replace('__BUMPINO_COUNT__',results.length).replace('{{ count }}',results.length).replace('__BUMPINO_TERMS__',initial.searchParams.get('q') || '').replace('{{ terms }}',initial.searchParams.get('q') || '');
      if (filtered) {
        const clear = document.createElement('a');const clearURL=new URL(initial);
        for (const name of [...clearURL.searchParams.keys()]) if (paramType(name) || name==='bm_page' || name==='page') clearURL.searchParams.delete(name);
        clear.href=clearURL.href;clear.textContent=data.messages.clear;clear.className='bumpino-catalog-clear';status.after(clear);
      }
      const navigation=document.createElement('nav');navigation.className='bumpino-catalog-pagination';navigation.setAttribute('aria-label',data.messages.page);container.append(navigation);
      for (const [page,label] of [[currentPage-1,data.messages.previous],[currentPage+1,data.messages.next]]) {
        if (page<1 || page>pages) continue;
        const link=document.createElement('a');const url=new URL(initial);url.searchParams.delete('page');url.searchParams.set('bm_page',page);link.href=url.href;link.textContent=label;navigation.append(link);
      }
      const pageLabel=document.createElement('span');pageLabel.textContent=`${currentPage} / ${pages}`;navigation.append(pageLabel);
      window.T4SThemeSP?.reinitProductGridItem?.();
    } catch (error) {
      container.replaceChildren();status.textContent=data.messages.error;
      if (searchHeading) searchHeading.textContent=data.messages.error;
      const retry=document.createElement('a');retry.href=initial.href;retry.textContent=data.messages.retry;status.after(retry);
    } finally {document.documentElement.classList.remove('bumpino-catalog-verifying');}
  };
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
